// API_BASE is validated lazily inside api-client.request() — not at module load.
// This preserves the offline-first guarantee: signed-out kids can play the game
// even if VITE_API_URL wasn't set at build time. The error surfaces only when
// a sync call is actually attempted.
export const API_BASE: string | undefined = import.meta.env.VITE_API_URL;
